export const reviews = [
  {
    name: "Marie D.",
    location: "Strasbourg",
    date: "15 mai 2026",
    rating: 5,
    text: "Mon oscillo-battant était bloqué depuis 3 jours. Le technicien est arrivé en 2h, a changé la crémone et tout fonctionne parfaitement. Service rapide et professionnel. Je recommande !",
  },
  {
    name: "Jean-Luc B.",
    location: "Schiltigheim",
    date: "22 mai 2026",
    rating: 5,
    text: "Fenêtre PVC qui ne fermait plus. Diagnostic gratuit, devis clair, intervention le lendemain. La pièce était comprise et la garantie 10 ans rassure. Très bon rapport qualité-prix.",
  },
  {
    name: "Sophie M.",
    location: "Haguenau",
    date: "28 avril 2026",
    rating: 5,
    text: "Ma poignée de fenêtre tournait dans le vide. Appel le matin, réparation l'après-midi. Le technicien était sympa et a tout expliqué. 5 étoiles méritées !",
  },
  {
    name: "Patrick L.",
    location: "Illkirch-Graffenstaden",
    date: "10 mai 2026",
    rating: 5,
    text: "Gond usé, vantail qui frottait. Le technicien a remplacé le gond et fait le réglage en 45 min. Très propre, pas de dégâts. J'ai gagné 300€ par rapport à un remplacement de fenêtre.",
  },
  {
    name: "Nathalie R.",
    location: "Bischheim",
    date: "02 mai 2026",
    rating: 5,
    text: "Fenêtre de la chambre qui ne fermait plus, impossible de dormir avec le froid. Appel en urgence, intervention le soir même. Merci DF PRO !",
  },
  {
    name: "Alain T.",
    location: "Sélestat",
    date: "18 avril 2026",
    rating: 5,
    text: "Crémone cassée sur une fenêtre ancienne. J'ai cru qu'il fallait tout changer. Le technicien a trouvé la pièce et a tout réparé. Super content du résultat.",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`ri-star-fill text-sm ${
            i < count ? "text-amber-400" : "text-[#D7E0E4]"
          }`}
        />
      ))}
    </div>
  );
}

export default function GoogleReviews() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#FF6B4A]" />
            <span className="text-sm font-medium text-[#1E3A47]">Avis vérifiés</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1E3A47] mb-4">
            Ce que disent nos clients
          </h2>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="flex items-center gap-1 bg-[#EEF2F4] rounded-full px-4 py-2">
              <i className="ri-google-fill text-[#1E3A47] w-4 h-4 flex items-center justify-center" />
              <span className="text-sm font-semibold text-[#1E3A47]">Google</span>
            </div>
            <div className="flex items-center gap-1">
              <Stars count={5} />
              <span className="text-sm font-semibold text-[#243038] ml-1">5,0 / 5</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, i) => (
            <div
              key={i}
              className="bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-6 md:p-8 flex flex-col"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#1E3A47] text-white flex items-center justify-center font-semibold text-sm">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-semibold text-sm text-[#243038]">{review.name}</p>
                    <p className="text-xs text-[#243038]/60">{review.location}</p>
                  </div>
                </div>
                <i className="ri-google-fill text-[#1E3A47] w-5 h-5 flex items-center justify-center" />
              </div>
              <Stars count={review.rating} />
              <p className="text-sm text-[#243038]/80 leading-relaxed mt-4 flex-1">
                &ldquo;{review.text}&rdquo;
              </p>
              <p className="text-xs text-[#243038]/50 mt-4">{review.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}